import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { InvoiceJustifications } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_INVOICEJUSTIFICATION_',
  }
);

export interface FetchInvoiceJustificationState {
  data: InvoiceJustifications | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchInvoiceJustificationRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: InvoiceJustifications;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchInvoiceJustificationState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchInvoiceJustificationState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchInvoiceJustificationState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchInvoiceJustificationState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchInvoiceJustificationState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchInvoiceJustification = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchInvoiceJustificationTypes = Types;
export const FetchInvoiceJustificationActions = Creators;
